/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const listForPortalUserEarlyRequestRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotThreadsService',
  rpcName: 'listForPortalUser',
  auth: 'app',
  fingerprint: 'sd0py8MLghxtCZ-TxwXTHC4LeGqkBzEE',
  earlyRequest: true,
  na1Only: false
};
export const getLatestOrCreateNewEarlyRequestRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotThreadsService',
  rpcName: 'getLatestOrCreateNew',
  auth: 'app',
  fingerprint: 'G8eeUMCCngcCaqqAHcBE2y4LeGqkBzEE',
  earlyRequest: true,
  na1Only: false
};
export const getThreadWithMessagesEarlyRequestRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotThreadsService',
  rpcName: 'getThreadWithMessages',
  auth: 'app',
  fingerprint: '5eDfoxWf4hAbrJFu8kFIxS4LeGqkBzEE',
  earlyRequest: true,
  na1Only: false
};